import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment OnboardingIntroduceAutopilotStep_org on Org {
      experiments
      optimisticSavingsForCurrentUserNextWeekErrorable {
        __typename

        ... on OptimisticSavings {
          couldCalculate
          savingMinutes
        }
      }
    }
  `,
};
